import { render } from "./SchoolListForm.vue?vue&type=template&id=74ec7b58&scoped=true"
import script from "./SchoolListForm.vue?vue&type=script&lang=js"
export * from "./SchoolListForm.vue?vue&type=script&lang=js"

import "./SchoolListForm.vue?vue&type=style&index=0&id=74ec7b58&scoped=true&lang=css"

import exportComponent from "C:\\Users\\hagino\\work\\src\\plus-manabi\\mplus-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74ec7b58"]])

export default __exports__